
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import { useEffect } from '@storybook/client-api';
import errorPrototype from './example/404.twig';
import offlinePrototype from './example/offline.twig';
import skyNavMenu from '../../components/sky-nav/demo/menu.json';
import groundNavMenu from '../../components/ground-nav/demo/menu.json';
import organization from '../../components/ground-nav/demo/organization.json';
import social from '../../components/ground-nav/demo/social.json';
import './example/example.scss';
const pageProps = {
  footer_class: 't-dark',
  skyNavMenu,
  menu: { items: [...skyNavMenu.items, ...groundNavMenu.items] },
  social,
  action: null,
  organization: {
    name: organization.name,
    address: {
      street_address: organization.address.street_address,
      address_locality: organization.address.address_locality,
      address_region: organization.address.address_region,
      postal_code: organization.address.postal_code,
      address_country: organization.address.address_country,
    },
    email: organization.email,
    telephone: organization.telephone,
    url: organization.url,
    founding_date: organization.founding_date,
  },
};
const fullHeight = () => {
  // Set this story's `body` element to full-height
  document.body.style.height = '100%';
  // Prevent Storybook's container from affecting this layout
  document.querySelector('#root').style.display = 'contents';
};


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Prototypes/Error Pages" parameters={{
      docs: {
        page: null
      },
      layout: 'fullscreen'
    }} mdxType="Meta" />
    <h1>{`Error Pages`}</h1>
    <p>{`Prototype layouts for 404 and Offline error pages. These use Cloud Cover
components, which should display full-height between a standard Sky Nav
and a Ground Nav with no action and the dark theme applied.`}</p>
    <h2>{`404 Page`}</h2>
    <Canvas mdxType="Canvas">
  <Story name="404" height="800px" parameters={{
        layout: 'fullscreen'
      }} mdxType="Story">
    {() => {
          useEffect(fullHeight);
          return errorPrototype(pageProps);
        }}
  </Story>
    </Canvas>
    <h2>{`Offline Page`}</h2>
    <Canvas mdxType="Canvas">
  <Story name="Offline" height="800px" parameters={{
        layout: 'fullscreen'
      }} mdxType="Story">
    {() => {
          useEffect(fullHeight);
          return offlinePrototype(pageProps);
        }}
  </Story>
    </Canvas>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export const _404 = (() => {
  useEffect(fullHeight);
  return errorPrototype(pageProps);
});
_404.storyName = '404';
_404.parameters = { storySource: { source: '() => {\n  useEffect(fullHeight);\n  return errorPrototype(pageProps);\n}' }, ...{
  layout: 'fullscreen'
} };

export const offline = (() => {
  useEffect(fullHeight);
  return offlinePrototype(pageProps);
});
offline.storyName = 'Offline';
offline.parameters = { storySource: { source: '() => {\n  useEffect(fullHeight);\n  return offlinePrototype(pageProps);\n}' }, ...{
  layout: 'fullscreen'
} };

const componentMeta = { title: 'Prototypes/Error Pages', parameters: {
  docs: {
    page: null
  },
  layout: 'fullscreen'
}, includeStories: ["_404","offline"],  };

const mdxStoryNameToKey = {"404":"_404","Offline":"offline"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;